import { deviceMap } from "../../define/define_list";
import { deviceManager } from "../../device/device_manager";
import type { PostSwitchDpi } from "../../driver/data_type/response";
import { dataProfileManage } from "../../snapshot/profile";

export const handleSwitchDPI = async (data: PostSwitchDpi) => {
    
    const dpiLen = deviceMap[deviceManager.deviceID].support.Limit.DpiLen
    if(data.DpiIndex < 0 || data.DpiIndex > dpiLen-1){
        throw new Error("DPI index out of range");
    }

    const config = dataProfileManage().dataProfile
    config.Mouse.DpiIndex = data.DpiIndex
    dataProfileManage().save()
    return deviceManager.deviceDriver.syncConfig()
}
